/* eslint-disable prettier/prettier */
import ConstructorIOClient, {
    RecommendationsResponse
} from '@constructor-io/constructorio-client-javascript';
import { BrowseResultsResponse, SearchResultsResponse } from './types';
import { getApiKey } from '../helpers';
import { Facet } from '../types';

export const constructorio = new ConstructorIOClient({
    apiKey: getApiKey()
});

export const fetchBrowseGroups = (groupId: string, params = {}) => {
    return new Promise((resolve, reject) => {
        constructorio.browse
            .getBrowseGroups({
                filters: {
                    group_id: groupId
                }
            })
            .then((response) => {
                resolve(response.response);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const fetchBrowseFacets = () => {
    return new Promise((resolve, reject) => {
        constructorio.browse
            .getBrowseFacets({
                resultsPerPage: 100
            })
            .then((response) => {
                resolve(response.response.facets as Facet[]);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const fetchBrowseResults = (
    filterName: string,
    filterValue: string,
    params = {}
): Promise<BrowseResultsResponse> => {
    return new Promise((resolve, reject) => {
        if (!filterName || typeof filterName !== 'string') {
            return Promise.reject(
                new Error('filterName should be a non-empty string.')
            );
        }
        if (!filterValue || typeof filterValue !== 'string') {
            return Promise.reject(
                new Error('filterValue should be a non-empty string.')
            );
        }

        constructorio.browse
            .getBrowseResults(filterName, filterValue, {
                ...params
            })
            .then((response) => {
                resolve(response.response as BrowseResultsResponse);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const fetchSearchResults = (
    query: string,
    params = {}
): Promise<SearchResultsResponse> => {
    return new Promise((resolve, reject) => {
        if (!query || typeof query !== 'string') {
            reject(new Error('Query must be a valid string'));
            return;
        }

        constructorio.search
            .getSearchResults(query, {
                ...params
            })
            .then((response) => {
                resolve(response.response);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const fetchRecommendations = (
    podId: string,
    params = {}
): Promise<RecommendationsResponse> => {
    return new Promise((resolve, reject) => {
        if (!podId || typeof podId !== 'string') {
            return Promise.reject(
                new Error('podId should be a non-empty string.')
            );
        }

        constructorio.recommendations
            .getRecommendations(podId, {
                ...params
            })
            .then((response) => {
                resolve(response as RecommendationsResponse);
            })
            .catch((error) => {
                reject(error);
            });
    });
};
